<template>
  <div class="p-4 bg-white rounded-lg h-100 poppins" v-if="pageData">
    <datatable-detail
      :table_properties="pageData?.properties"
    ></datatable-detail>
    <div class="row px-4 py-6">
      <div class="col-12 text-h6 font-weight-bold text--disabled py-0 my-0">
        Input
      </div>
      <div class="col-12">
        <v-text-field
          outlined
          :label="$t('address')"
          v-model="formData.address"
          :error-messages="addressErrors"
          clearable
          @input="$v.formData.address.$touch()"
          @blur="$v.formData.address.$touch()"
        ></v-text-field>
      </div>
      <div class="col-12 d-flex justify-center pa-0 ma-0">
        <button @click.prevent="resetData" class="btn btn-secondary mx-1">
          <span class="svg-icon">
            <v-icon size="18">mdi-refresh</v-icon>
          </span>
          Reset
        </button>
        <button @click.prevent="submitData" class="btn btn--export-filter mx-1">
          <span class="svg-icon">
            <v-icon size="18">mdi-check-network-outline</v-icon>
          </span>
          Validate
        </button>
      </div>
      <div class="col-12">
        <div class="text-h6 font-weight-bold text--disabled pb-4">Output</div>
        <div
          class="border pa-4 d-flex flex-column poppins"
          style="border-radius: 10px"
        >
          <!--          <span v-for="[name, value] in serverData">-->
          <span v-for="(value, key) in serverData" :key="key">
            <span class="text-capitalize">{{ key }}</span
            >: {{ value }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import DatatableDetail from "@/own/components/datatable/DatatableDetail";
import ApiService from "@/core/services/api.service";
import validationMixin from "@/own/mixins/validationMixin";
import { required } from "vuelidate/lib/validators";
export default {
  name: "AddressValidator",
  components: { DatatableDetail },
  mixins: [validationMixin],
  validations() {
    return {
      formData: {
        address: {
          required,
        },
      },
    };
  },
  beforeMount() {
    this.loadDataFromServer();
  },
  data: () => ({
    table_properties: {
      title: "Address Validator",
      description: "Validate addresses using AI module.",
    },
    formData: {
      address:
        "Emirates. Street: P.O Box 34823. City: Dubai. State/province/area: Dubai",
    },
    serverData: {},
    pageData: null,
  }),
  methods: {
    loadDataFromServer() {
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post("/settings/address_validator")
        .then(({ data }) => {
          this.pageData = data.data;
        })
        .catch()
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    resetData() {
      this.formData.address =
        "Emirates. Street: P.O Box 34823. City: Dubai. State/province/area: Dubai";
      this.serverData = {};
    },
    submitData() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post(
        "/settings/address_validator/address-correction",
        this.formData
      )
        .then(({ data }) => {
          this.serverData = data.data;
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
  computed: {
    addressErrors() {
      return this.handleFormValidation("address", this, "formData");
    },
  },
};
</script>
<style lang="scss">
.input-group-bordered {
  border: 1px solid #dcdfe8 !important;
}
.form-group-label {
  top: 3px;
  left: 30px;
  background: white;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
</style>
